﻿import { TripChallan } from './TripChallan';
import { Trpdbvoucherdetail } from '../Trpdbvoucherdetail';
import { Trpdbvoucher } from 'src/app/Model/Trpdbvoucher';
import { TripExpense } from './TripExpense';

export class Texpense {
	public Voucher: Trpdbvoucher | undefined;
	public VoucherDetail: Trpdbvoucherdetail[] = [];
	public TripExpense: TripExpense | undefined;
	public Tchallan: TripChallan[] = [];
}
